import { AxiosError } from 'axios';
import { defineStore } from 'pinia';
import { v4 as uuid } from 'uuid';

import { AlertProps } from './alert-props.interface';

interface AlertItem extends AlertProps {
  id: string;
  timer: ReturnType<typeof setTimeout>;
}

const closeTimeout = 5000;

export const useAlertsStore = defineStore({
  id: 'alerts',
  state: (): {
    alerts: AlertItem[];
  } => ({
    alerts: [],
  }),
  getters: {},
  actions: {
    success(text: string): void {
      this.show({ text, variant: 'success' });
    },

    info(text: string): void {
      this.show({ text, variant: 'info' });
    },

    error(text: string): void {
      this.show({ text, variant: 'error' });
    },

    somethingWentWrong(): void {
      this.error('Something went wrong. Please try again later.');
    },

    warning(text: string): void {
      this.show({ text, variant: 'warning' });
    },

    catchError(error: any): void {
      if (error instanceof AxiosError) {
        const message = error.response?.data?.message || error.response?.data?.message?.message;

        if (message) {
          return this.error(message);
        }
      }

      this.somethingWentWrong();
    },

    show(options: AlertProps): string {
      const id = `alert-${uuid()}`;

      this.alerts.push({
        id,
        ...options,
        timer: setTimeout(() => this.close(id), closeTimeout),
      });

      return id;
    },

    close(alertId: string) {
      const alertIndex = this.alerts.findIndex((alert) => alert.id === alertId);

      if (alertIndex === -1) {
        return;
      }

      const alert = this.alerts[alertIndex];

      clearTimeout(alert.timer);
      this.alerts.splice(alertIndex, 1);
    },
  },
});
